import React from "react";

export const TaskSubmittedSuccess: React.FC = () => (
  <div className="border-green-20 flex flex-col items-center justify-center rounded-md p-8">
    <svg
      className="mb-3 h-12 w-12 text-green-500"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="white" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 12l3 3 5-5" stroke="currentColor" strokeWidth="2" />
    </svg>
    <h2 className="mb-1 text-xl font-semibold text-green-700">Task Submitted</h2>
    <p className="text-green-700">Your task was submitted successfully and marked as done.</p>
  </div>
);
